// Each environment's config lives in its own file (environments.prod.js,
// environments.dev.js, environments.local.js). The active bundle is selected at
// build time by REACT_APP_APPLI_ENV (set in .env.local, defaults to "prod").
//
// "local" is the harness bundle — every host on this machine. It is reachable only
// by asking for it by name, so "dev" and "prod" resolve exactly as they always did.
//
// CRA inlines the env var at build time, so only the selected config's
// import survives dead-code elimination — the other environment's values
// never ship in the production bundle.
import devConfig from './environments.dev';
import localConfig from './environments.local';
import prodConfig from './environments.prod';

const APPLI_ENV = process.env.REACT_APP_APPLI_ENV || "prod";

const selected =
    APPLI_ENV === "local" ? localConfig :
    APPLI_ENV === "dev" ? devConfig :
    prodConfig;

// One host, overridable at build time. `e2e/services-dev.sh` runs the *dev* bundle —
// real dev Firebase, real dev core-api, real Google sign-in — against a
// candidate-portal-backend on this machine, and that must not mean editing
// environments.dev.js, which is what the deployed dev build reads. It is deliberately
// only this one host: Firebase and core-api stay the dev project's, so a session
// minted here is a real one.
//
// Unset in every real build, where CRA inlines it as `undefined` and the minifier
// folds the branch away, leaving the selected bundle exactly as written.
const CANDIDATE_API_OVERRIDE = process.env.REACT_APP_CANDIDATE_API_URL;

// The admin portal that may frame this app as an admin view, overridable for the same reason
// and in the same way: `e2e/services-dev.sh` runs the *dev* bundle — real dev Firebase, real
// sign-in — against an admin portal on this machine, and that must not mean editing
// environments.dev.js, which is what the deployed dev build reads.
//
// Unset in every real build, where CRA inlines it as `undefined` and the branch folds away.
const ADMIN_PORTAL_ORIGIN_OVERRIDE = process.env.REACT_APP_ADMIN_PORTAL_ORIGIN;

// core-api — sign-in and the session cookie — overridable for the same reason and in the same
// way. `e2e/services-dev.sh` runs core-api *locally* from origin/main (the deployed dev build is
// stale and cannot sign in an account that holds an entry), and the dev bundle has to reach that
// one without editing environments.dev.js. Firebase stays the dev project's, so the token this
// host verifies is a real one.
//
// Unset in every real build, where CRA inlines it as `undefined` and the branch folds away.
const CORE_API_OVERRIDE = process.env.REACT_APP_CORE_API_URL;

const env = {
    ...selected,
    ...(CANDIDATE_API_OVERRIDE ? { candidateApiUrl: CANDIDATE_API_OVERRIDE } : {}),
    ...(ADMIN_PORTAL_ORIGIN_OVERRIDE ? { adminPortalOrigin: ADMIN_PORTAL_ORIGIN_OVERRIDE } : {}),
    ...(CORE_API_OVERRIDE ? { coreApiUrl: CORE_API_OVERRIDE } : {}),
};

export default env;
export const APPLI_ENV_NAME = APPLI_ENV;
